/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState, useEffect } from 'react';

import './assets/vendor/bootstrap/css/bootstrap.min.css';
import './assets/vendor/bootstrap-icons/bootstrap-icons.css';

import { preload } from './utils/preload';

import {
  HeaderComp,
  IHeaderCompProps,
  HeroSection,
  IHeroSectionProps,
  AboutSection,
  IAboutSectionProps,
  ValueSection,
  IValueSectionProps,
  Testimonial,
  ITestimonialProps,
  Clients,
  IClientsProps,
  Team,
  ITeamProps,
  Contact,
  IContactProps,
  Footer,
  IFooterProps,
  Pricing,
  IPricingProps,
  Features,
  IFeatureProps,
  HelmetComp,
  IHelmetCompProps,
} from './components';

export interface IMainSectionProps {
  type:
    | 'value'
    | 'testimonial'
    | 'clients'
    | 'team'
    | 'pricing'
    | 'features'
    | 'about'
    | 'contact';
  compProps:
    | IValueSectionProps
    | ITestimonialProps
    | IClientsProps
    | ITeamProps
    | IPricingProps
    | IFeatureProps
    | IAboutSectionProps
    | IContactProps;
}

export interface ILandingPageProps {
  mainSection: IMainSectionProps[];
}

type ILandingPageType = ILandingPageProps &
  IHeaderCompProps &
  IHeroSectionProps &
  IAboutSectionProps &
  IValueSectionProps &
  ITestimonialProps &
  IClientsProps &
  ITeamProps &
  IContactProps &
  IFooterProps &
  IPricingProps &
  IFeatureProps &
  IHelmetCompProps;

export const LandingPage = ({ mainSection, ...rest }: ILandingPageType) => {
  // const [loaded, setLoaded] = useState(false);
  // useEffect(() => {
  //     preload(() => setLoaded(true));
  // }, []);
  preload();

  const getMainSection = () => {
    let _comp: any = [];
    for (let i = 0; i < mainSection?.length; ++i) {
      const section = mainSection[i];
      switch (section?.type) {
        case 'about':
          _comp.push(
            <AboutSection
              key={`${section.type}-${i}`}
              {...(section?.compProps || {})}
            />
          );
          break;
        case 'value':
          _comp.push(
            <ValueSection
              key={`${section.type}-${i}`}
              {...(section?.compProps || {})}
            />
          );
          break;
        case 'features':
          _comp.push(
            <Features
              key={`${section.type}-${i}`}
              {...(section?.compProps || {})}
            />
          );
          break;
        case 'clients':
          _comp.push(
            <Clients
              key={`${section.type}-${i}`}
              {...(section?.compProps || {})}
            />
          );
          break;
        case 'testimonial':
          _comp.push(
            <Testimonial
              key={`${section.type}-${i}`}
              {...(section?.compProps || {})}
            />
          );
          break;
        case 'team':
          _comp.push(
            <Team
              key={`${section.type}-${i}`}
              {...(section?.compProps || {})}
            />
          );
          break;
        case 'pricing':
          _comp.push(
            <Pricing
              key={`${section.type}-${i}`}
              {...(section?.compProps || {})}
            />
          );
          break;
        case 'contact':
          _comp.push(
            <Contact
              key={`${section.type}-${i}`}
              {...(section?.compProps || {})}
            />
          );
          break;
      }
    }
    return _comp;
  };

  const _renderMainSection = () => {
    return (
      <main id='main'>
        {getMainSection()}
        {/*<AboutSection {...rest} />*/}
        {/*<ValueSection {...rest} />*/}
        {/*<Features {...rest} />*/}
        {/*<Pricing {...rest} />*/}
        {/*<Testimonial {...rest} />*/}
        {/*<Clients {...rest} />*/}
        {/*<Team {...rest} />*/}
        {/*<Contact {...rest} />*/}
      </main>
    );
  };

  return (
    <div>
      <HelmetComp {...rest} />
      <HeaderComp {...rest} />
      <HeroSection {...rest} />
      {_renderMainSection()}
      <Footer {...rest} />
      <a
        href='#'
        className='back-to-top d-flex align-items-center justify-content-center'
      >
        <i className='bi bi-arrow-up-short' />
      </a>
    </div>
  );
};

LandingPage.defaultProps = {
  headerLink: '/',
};
